import removeAccents from 'utils/removeAccents';

const removeAccentsQuickFilterFn = value => {
  const val = removeAccents(value.toLowerCase());
  return params => removeAccents(params.value.toLowerCase()).includes(val);
};

export default removeAccentsQuickFilterFn;
